import { SignIn } from "@clerk/clerk-react"
import { Link } from "react-router-dom"
import { nextFromLocation, postLoginDestination } from "./returnTo"

export const ClerkLogin = () => {

    const { hostname } = window.location;
    const shouldRedirect = hostname.includes('freedomsoft.com');
    // LNK-1: carry the page they were trying to open through every sign-in route
    const next = postLoginDestination(nextFromLocation(), "");
    const carry = next ? `?next=${encodeURIComponent(next)}` : "";

    if (shouldRedirect) {
        window.location.href = `/login${carry}`;
        return null;
    }

    return (
        <div className="flex items-center justify-center w-full min-h-screen">
            <div>
                <SignIn 
                    signUpUrl="https://www.launchos.com" 
                    forceRedirectUrl={`/authVerify${carry}`}
                    appearance={{
                        elements: {
                            formFieldInput: "bg-transparent p-3 rounded"
                        }
                    }}
                />
                <p className="text-center p-4 text-black/70 dark:text-white/70">
                    Trouble Signing In? <Link to={`/login${carry}`} className="underline">Try the Old Login Page</Link>
                </p>
            </div>
        </div>
    )
}